import { useTranslation } from 'react-i18next'
import type { ForecastView } from '@gk/contracts'
import { useClub } from '../club/ClubProvider.tsx'
import { ageText } from '../data/weatherForecast.ts'
import { formatLocal } from '../lib/time.ts'
import { Pill } from './components.tsx'

/** M24 review: the newest issue was received, but it covers no hour to come (a connector switched off, or failing, for more than the issue's ten days): every
 *  forecast surface says so, with the issue time, its age and the grey "ancienne" pill — never "Aucune prévision reçue" (one was), never an empty list or a
 *  source line under no figure. */
export function NoFutureLine({ view, ageMs, stale, testId }: { view: Pick<ForecastView, 'issue'>; ageMs: number; stale: boolean; testId: string }) {
  const { t } = useTranslation()
  const { site } = useClub()
  return (
    <p className="meta flex flex-wrap items-center gap-2" data-testid={testId}>
      <span>{t('forecast.noFuture', { date: formatLocal(view.issue.issued_at, site.timezone, 'dd/MM'), time: formatLocal(view.issue.issued_at, site.timezone, 'HH:mm'), age: ageText(ageMs, t) })}</span>
      {stale && <Pill tone="gray"><span data-testid={`${testId}-stale`}>{t('forecast.stale')}</span></Pill>}
    </p>
  )
}
